<template>
    <v-row justify="end">
        <v-dialog v-model="dialog" scrollable max-width="700px">
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" color="grey darken-2" fab dark small style="z-index:4; position: relative; top:-20px;">
                    <i class="mdi mdi-24px mdi-math-log"></i>
                </v-btn>
            </template>
            <v-card indigo>
                <v-card-title>Calculation Detail Log</v-card-title>
                <v-divider></v-divider>
                <v-card-text  style="height: 300px;">
<pre>{{ content }}</pre>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn small color="primary" @click="dialog = false">Close</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
export default {
    name: "LogPopout",
    props: {
        content: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            dialog: false
        }
    }
}
</script>